import * as React from 'react';
import Tile from '..';
import { getText } from '../../../helpers';
import buildUrl from '../../../utilities/build-url';
import buildImageUrl from '../../../utilities/build-image-url';

export default function DatasetTile(props: DatasetTileProps) {
    const { className, dataProfile, newTab } = props;
    const { dataProvider, name, urlName, absoluteName, shortDescription, thumbnailImageFilePath, addedDate, enhancementDate, id, isBundle } = dataProfile;
    const langCode = getText('langCode');
    const datasetPathSegment = buildUrl(absoluteName || urlName || name, id);
    let url = isBundle ? `/${langCode}/datasets/bundle/${datasetPathSegment}` : `/${langCode}/datasets/${datasetPathSegment}`;
    if (newTab) url = window.location.origin.concat(url);
    const dataProviderForDisplay = dataProvider && dataProvider.split(',').length > 1 ? getText('generic.multipleVendor') : dataProvider;

    // TEMPORARY HACK
    // const fileName = thumbnailImageFilePath && thumbnailImageFilePath.match(/[^/]+$/g);
    // const pathOverride = (fileName && `${process.env.PUBLIC_URL}/api/crownpeak/_assets/images/marketplace/${fileName}`) || undefined;
    //
    const pathOverride = buildImageUrl(thumbnailImageFilePath);

    return (
        <Tile
            className={className}
            provider={dataProviderForDisplay}
            name={name}
            description={shortDescription}
            buttonText={getText('generic.viewDataset')}
            imgUrl={pathOverride}
            url={url}
            addedDate={addedDate}
            enhancementDate={enhancementDate}
            tileType={isBundle ? 'DatasetBundles' : 'Datasets'}
            id={id}
        />
    );
}
